import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgMessageBubble = function SvgMessageBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.5414 22 9.1537 21.6873 7.90214 21.1243C7.8268 21.0904 7.7584 21.0866 7.70706 21.0981L4.23593 21.8784C2.96971 22.1631 1.84512 21.0189 2.15152 19.7578L2.96071 16.428C2.97373 16.3744 2.96997 16.3022 2.93326 16.2236C2.33424 14.9396 2 13.5077 2 12ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.2841 3.78425 14.4997 4.29256 15.5893C4.45968 15.9474 4.5191 16.3674 4.41829 16.7822M4.41829 16.7822L3.60912 20.112C3.56533 20.2923 3.72604 20.4556 3.90683 20.415L7.3779 19.6347C7.77468 19.5455 8.17384 19.6018 8.5174 19.7563C9.57925 20.2339 10.7576 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5"
  })));
};

export { SvgMessageBubble as ReactComponent };
//# sourceMappingURL=message--bubble.svg.js.map
